import styled from 'styled-components';
import { Overlay as BPOverlay } from '@blueprintjs/core';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
var Overlay = styled(BPOverlay).withConfig({
  displayName: "Wizardstyles__Overlay",
  componentId: "sc-5cck0k-0"
})(["width:100%;height:100%;"]);
var Wizard = styled.div.withConfig({
  displayName: "Wizardstyles__Wizard",
  componentId: "sc-5cck0k-1"
})(["background:var(--dentsu-color-white);width:100%;height:100%;display:flex;flex-direction:column;.", "-progress-bar{border-radius:0;height:", ";}.", "-progress-bar__indicator{border-radius:0 4px 4px 0;top:30%;height:40%;}"], prefix, rem(10), prefix);
var ScrollBody = styled.div.withConfig({
  displayName: "Wizardstyles__ScrollBody",
  componentId: "sc-5cck0k-2"
})(["flex:1;overflow:auto;"]);
export var Styled = {
  Overlay: Overlay,
  Wizard: Wizard,
  ScrollBody: ScrollBody
};